var _mask, _g, _mask2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniVigilanciaResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "g2yb99a1ba",
    width: 22,
    height: 10,
    x: 9,
    y: 12,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 13h22v8.096H9V13z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g2yb99a1ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M20.222 19.193c-.12.133-.327.133-.447 0-.446-.495-1.397-1.721-1.397-3.155 0-.571 3.24-.594 3.24 0 0 1.434-.952 2.66-1.396 3.155zm-.557-6.111L9.522 17.748c-.479.22-.665.802-.404 1.258l.936 1.639c.16.279.457.45.778.45h18.332c.322 0 .62-.171.778-.45l.94-1.644c.26-.455.074-1.037-.402-1.257l-10.064-4.661c-.238-.11-.512-.111-.75-.001z",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "gtdvrvyejb",
    width: 18,
    height: 5,
    x: 11,
    y: 23,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.11 23.508h17.778v4.289H11.11v-4.29z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gtdvrvyejb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M11.588 23.508c-.33 0-.561.33-.45.64.196.546.476 1.049.822 1.5.06.075.12.15.181.222.15.175.312.339.482.494.977.888 2.27 1.433 3.69 1.433h7.372c1.42 0 2.713-.545 3.689-1.433.26-.236.5-.495.713-.778.023-.033.046-.07.07-.102.291-.41.53-.86.703-1.34.111-.308-.122-.636-.45-.636H11.587z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniVigilanciaResting);
export default __webpack_public_path__ + "static/media/icon_mini_vigilancia_resting.37ed353b4606ebbda6c8086394d36cbc.svg";
export { ForwardRef as ReactComponent };